import * as appMain from '@edf-pkg/app-main';

import { useAuthenticationStore } from '../auth';
import {
    AUTHENTICATION_ENDPOINT,
    CHECK_MFA_ENDPOINT,
    EDEN_CONFIRMATION_ENDPOINT,
    FORGET_PASSWORD_ENDPOINT,
    RESET_PASSWORD_ENDPOINT,
    UPDATE_USER_EMAIL_ENDPOINT,
    UPDATE_USER_PHONE_NUMBER_ENDPOINT,
} from '../constants';

export const isUserAuthenticated = (): boolean => {
    const userData = appMain.utils.user.getAuthData();
    const authData = useAuthenticationStore.getState();

    return Boolean(userData.username && userData.username !== 'anonymous' && userData.role && authData?.accessToken);
};

export const isAutoLogoutOccurred = (): boolean => {
    const autoLogoutFlag = localStorage.getItem(process.env.REACT_APP_AUTO_LOGOUT_FLAG_STORAGE_KEY || '');
    if (autoLogoutFlag != null) {
        return JSON.parse(autoLogoutFlag);
    }
    return false;
};

export const setAutoLogoutLocalStorageFlag = (isTrue: boolean): void => {
    if (isTrue) {
        localStorage.setItem(process.env.REACT_APP_AUTO_LOGOUT_FLAG_STORAGE_KEY || '', JSON.stringify(isTrue));
    } else {
        localStorage.removeItem(process.env.REACT_APP_AUTO_LOGOUT_FLAG_STORAGE_KEY || '');
    }
};

export const isPublicEndpoint = (endpoint: string | undefined): boolean => {
    if (endpoint) {
        const endpointWithTrimmedSlashes = endpoint.replace(/^\/|\/$/g, '');

        const publicEndpoints = [
            AUTHENTICATION_ENDPOINT,
            FORGET_PASSWORD_ENDPOINT,
            RESET_PASSWORD_ENDPOINT,
            CHECK_MFA_ENDPOINT,
            EDEN_CONFIRMATION_ENDPOINT,
            UPDATE_USER_EMAIL_ENDPOINT,
            UPDATE_USER_PHONE_NUMBER_ENDPOINT,
        ];

        return publicEndpoints.includes(endpointWithTrimmedSlashes);
    }
    return false;
};
